import { render, staticRenderFns } from "./SessionStart.vue?vue&type=template&id=476897b9&scoped=true&"
import script from "./SessionStart.vue?vue&type=script&lang=js&"
export * from "./SessionStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476897b9",
  null
  
)

export default component.exports